import { SelectProps, Theme } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { CALENDAR_DEFAULT_USER_FILTER } from '../../../sic-lib/defaults';
import { getCalendarUserFilters } from '../../../sic-lib/utils/calendarEventHelpers';
import { setUserFilter } from '../../../store/calendar';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        minWidth: '200px',
    },
    menuItem: {
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.menuListHover.main,
            '&:hover': {
                backgroundColor: theme.palette.menuListHover.main,
            },
        },
    },
}));

export default function SelectCalendarUser({ ...props }: SelectProps) {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const users = useAppSelector(state => state.user?.users || []);
    const userFilter = useAppSelector(
        state => state.calendar?.userFilter || CALENDAR_DEFAULT_USER_FILTER,
    );

    const filterItems = React.useMemo(
        () => getCalendarUserFilters(users?.map(x => x.userName)),
        [users],
    );

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(setUserFilter(filterItems.find(x => x.userName === event.target.value)!));
    };

    return (
        <TextField
            {...(props as TextFieldProps)}
            select
            className={classes.root}
            id={props.id || 'filter_by_user'}
            label={props.label || 'Filter by User'}
            value={userFilter.userName}
            onChange={handleChange}
        >
            {filterItems.map(item => (
                <MenuItem className={classes.menuItem} key={item.label} value={item.userName}>
                    {item.label}
                </MenuItem>
            ))}
        </TextField>
    );
}
